export class ProfileSettingsModel {

    public isInit: boolean = true;

    public pictureUrl: string = null;
    public name: string = null;
    public team: string = null;
    public position: string = null;
    public bio: string = null;
    public email: string = null;
    public chatAddress: string = null;
    public homePhone: string = null;
    public workPhone: string = null;
    public address: string = null;
    public memberSince: string = null;

    public editProfileDialogModel: EditProfileDialogModel = null;
    public changeImageDialogModel: ChangeImageDialogModel = null;

}

export class EditProfileDialogModel {

    public constructor(
        public name: string,
        public position: string,
        public bio: string,
        public chat: string,
        public workPhone: string,
        public homePhone: string,
        public address: string,
        public memberSince: string
    ) { }

    public nameError: string = null;

}

export class ChangeImageDialogModel {

    public imageError: string = null;

}
